import { useNavigationParams } from '../../system/useNavigationParams'
import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'
import { useConciseChangesets } from './useConciseChangesets'

export const useCurrentBranchConciseChangesets = ({
  shouldIncludeBaseConciseChangesets,
}: {
  shouldIncludeBaseConciseChangesets: boolean
}) => {
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const { branch: currentBranch, server: currentServer } = useNavigationParams()
  return useConciseChangesets({
    workspaceKey: currentWorkspaceKey,
    branchKey: currentBranch
      ? {
          name: currentBranch,
          server: currentServer,
        }
      : undefined,
    shouldIncludeBaseConciseChangesets,
  })
}
